
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 5a5 5 0 015-5h50a5 5 0 015 5v30a5 5 0 01-5 5H5a5 5 0 01-5-5V5z","fill":"#179BD7"}}),_c('path',{attrs:{"opacity":".33","d":"M37.856 14.607c-.02.131-.044.265-.07.403-.905 4.644-4 6.25-7.953 6.25h-2.012a.978.978 0 00-.966.827l-1.031 6.535-.292 1.853a.515.515 0 00.508.595h3.57a.859.859 0 00.849-.724l.035-.181.672-4.266.043-.233a.858.858 0 01.848-.726h.534c3.459 0 6.166-1.404 6.958-5.468.33-1.697.16-3.114-.716-4.111a3.41 3.41 0 00-.977-.754z","fill":"#fff"}}),_c('path',{attrs:{"d":"M28.031 14.63a.855.855 0 01.848-.724h5.377c.637 0 1.231.042 1.774.13a7.158 7.158 0 011.083.258c.267.088.515.193.744.313.27-1.716-.002-2.885-.93-3.943C35.904 9.499 34.057 9 31.694 9h-6.86a.98.98 0 00-.97.829L21.008 27.94a.59.59 0 00.582.681h4.235l1.063-6.747 1.144-7.244z","fill":"#fff"}}),_c('path',{attrs:{"opacity":".66","d":"M36.91 14.23a7.119 7.119 0 00-.88-.195 11.187 11.187 0 00-1.774-.13h-5.377a.853.853 0 00-.848.726l-1.144 7.245-.032.21a.978.978 0 01.966-.827h2.012c3.953 0 7.049-1.605 7.953-6.25.027-.137.05-.27.07-.402a4.817 4.817 0 00-.946-.377z","fill":"#fff"}})])
          )
        }
      }
    